module.exports = __webpack_public_path__ + "img/Timeline.84b6c868.png";